(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4cc0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4cc0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $1RzFG = parcelRequire("1RzFG");
"use strict";
var $197cd56b15c33885$var$buttonsLang = document.querySelectorAll(".language__button");
$197cd56b15c33885$var$buttonsLang.forEach(function(button) {
    button.addEventListener("click", function() {
        $197cd56b15c33885$var$changeLanguageSwitherStyle(button.value);
        $197cd56b15c33885$var$changeLanguage(button.value);
    });
});
// змінення стилів для кнопок
function $197cd56b15c33885$var$changeLanguageSwitherStyle(lang) {
    $197cd56b15c33885$var$buttonsLang.forEach(function(button) {
        if (button.value === lang) button.classList.add("language__button--active");
        else button.classList.remove("language__button--active");
    });
}
// змінення мови для тексту
function $197cd56b15c33885$var$changeLanguage(lang) {
    var _loop = function(key) {
        document.querySelectorAll(".lng-" + key).forEach(function(element) {
            element.innerHTML = (0, $1RzFG.default)[key][lang];
        });
    };
    for(var key in 0, $1RzFG.default)_loop(key);
}
// слайдер
var $197cd56b15c33885$var$swiper = new Swiper(".swiper", {
    autoHeight: true,
    slidesPerView: 1,
    spaceBetween: 56,
    slidesPerColumnFill: "column",
    navigation: {
        nextEl: ".swiper-feature__button-next",
        prevEl: ".swiper-feature__button-prev"
    },
    breakpoints: {
        1280: {
            slidesPerView: 2,
            spaceBetween: 56,
            grid: {
                rows: 2
            }
        }
    }
});
var $197cd56b15c33885$var$swiperCurrentSlide = document.querySelector(".swiper-feature__curent");
var $197cd56b15c33885$var$swiperAllSlides = document.querySelector(".swiper-feature__total");
var $197cd56b15c33885$var$swiperBtnPrev = document.querySelector(".swiper-feature__button-prev");
var $197cd56b15c33885$var$swiperBtnNext = document.querySelector(".swiper-feature__button-next");
$197cd56b15c33885$var$swiperAllSlides.innerHTML = $197cd56b15c33885$var$swiper.slides.length > 9 ? $197cd56b15c33885$var$swiper.slides.length : "0" + $197cd56b15c33885$var$swiper.slides.length;
function $197cd56b15c33885$var$updateNavigationButtons() {
    $197cd56b15c33885$var$swiper.realIndex > 0 ? $197cd56b15c33885$var$swiperBtnPrev.classList.add("swiper-feature__button--active") : $197cd56b15c33885$var$swiperBtnPrev.classList.remove("swiper-feature__button--active");
    $197cd56b15c33885$var$swiper.realIndex === $197cd56b15c33885$var$swiper.slides.length - 1 ? $197cd56b15c33885$var$swiperBtnNext.classList.remove("swiper-feature__button--active") : $197cd56b15c33885$var$swiperBtnNext.classList.add("swiper-feature__button--active");
}
function $197cd56b15c33885$var$updateCurrentSlide() {
    var currentSlide = $197cd56b15c33885$var$swiper.realIndex + 1;
    $197cd56b15c33885$var$swiperCurrentSlide.innerHTML = currentSlide > 9 ? currentSlide : "0" + currentSlide;
}
$197cd56b15c33885$var$updateCurrentSlide();
$197cd56b15c33885$var$updateNavigationButtons();
$197cd56b15c33885$var$swiper.on("slideChange", function() {
    $197cd56b15c33885$var$updateCurrentSlide();
    $197cd56b15c33885$var$updateNavigationButtons();
});
// анімації
AOS.init();
AOS.init({
    duration: 800,
    easing: "ease-out"
});

})();
//# sourceMappingURL=index.f49fef5f.js.map
